import { render } from "./QuestDialog10_2.vue?vue&type=template&id=5b4d0d3f"
import script from "./QuestDialog10_2.vue?vue&type=script&lang=js"
export * from "./QuestDialog10_2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/questDialogs/QuestDialog10_2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b4d0d3f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b4d0d3f', __exports__)) {
    api.reload('5b4d0d3f', __exports__)
  }
  
  module.hot.accept("./QuestDialog10_2.vue?vue&type=template&id=5b4d0d3f", () => {
    api.rerender('5b4d0d3f', render)
  })

}


export default __exports__